import алтай from "./алтай";
import арвайхээр from "./арвайхээр";
import багануур from "./багануур";
import баруунбүс from "./баруун бүс";
import баруунурт from "./баруун-урт";
import баянгол from "./баянгол";
import баянзүрх from "./баянзүрх";
import баянхонгор from "./баянхонгор";
import булган from "./булган";
import говийнбүс from "./говийн бүс";
import даланзадгад from "./даланзадгад";
import дархан from "./дархан";
import зуунмод from "./зуунмод";
import зүүнбүс from "./зүүн бүс";
import мандалговь from "./мандалговь";
import мөрөн from "./мөрөн";
import налайх from "./налайх";
import өлгий from "./өлгий";
import сайншанд from "./сайншанд";
import партизан from "./партизан";
import буянтухаа from "./буянт-ухаа";
import сүхбаатар from "./сүхбаатар";
import тосонцэнгэл from "./тосонцэнгэл";
import төвийнбүс from "./төвийн бүс";
import улаанбаатар from "./улаанбаатар";
import улаангом from "./улаангом";
import улиастай from "./улиастай";
import хануул from "./хан-уул";
import ховд from "./ховд";
import цэцэрлэг from "./цэцэрлэг";
import чингис from "./чингис";
import өлзийт from "./өлзийт";
import чойбалсан from "./чойбалсан";
import чойр from "./чойр";
import эрдэнэт from "./эрдэнэт";
import хатгал from "./хатгал";
import ханбогд from "./ханбогд";
import замынүүд from "./замын-үүд";

export default {
  алтай,
  арвайхээр,
  багануур,
  баруунбүс,
  баруунурт,
  баянгол,
  баянзүрх,
  баянхонгор,
  булган,
  говийнбүс,
  даланзадгад,
  дархан,
  зуунмод,
  зүүнбүс,
  мандалговь,
  мөрөн,
  налайх,
  өлгий,
  сайншанд,
  партизан,
  буянтухаа,
  сүхбаатар,
  тосонцэнгэл,
  төвийнбүс,
  улаанбаатар,
  улаангом,
  улиастай,
  хануул,
  ховд,
  цэцэрлэг,
  чингис,
  өлзийт,
  чойбалсан,
  чойр,
  эрдэнэт,
  хатгал,
  ханбогд,
  замынүүд
};
